export const api = process.env.REACT_APP_API_URL;
export const accessTokenKey = process.env.ACCESS_TOKEN_SECRET;
export const refreshTokenKey = process.env.REFRESH_TOKEN_SECRET;
